var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/nodes/button.ts
import { acss } from "@adornis/chemistry/directives/acss.js";
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-button.js";
import "@adornis/chemistry/elements/components/x-flex.js";
import "@adornis/forms/x-checkbox.js";
import "@adornis/forms/x-input.js";
import "@adornis/popover/x-dropdown-selection.js";
import { goTo } from "@adornis/router/client/open-href.js";
import { html } from "lit";
import { customElement } from "lit/decorators.js";
import { BUTTON_KEY, BUTTON_SCHEMA } from "../../schema/nodes/button.js";
import { PARAGRAPH_KEY } from "../../schema/nodes/paragraph.js";
import { BuildifyLitElement } from "../BuildifyLitElement.js";
import { runInsertNode } from "../helper/runInsertNode.js";
import { isNodeSelection } from "../util.js";
var editor = ({ host, content, contentController, controllerBaseKeyPath }) => {
  return html`
    <x-flex space="md">
      <x-input
        placeholder="URL"
        ${contentController.field(...controllerBaseKeyPath, "href")}
        icon="open_in_browser"
        @icon-click=${() => {
    if (content.href)
      goTo(content.href);
    contentController.validate();
  }}
      >
      </x-input>
      <x-dropdown-selection
        placeholder="Wo soll der Link aufgehen?"
        ${contentController.field(...controllerBaseKeyPath, "target")}
        .selectables=${["_self", "_blank"]}
        .renderString=${(target) => target ? { _self: "Im aktuellen Fenster", _blank: "In einem neuen Fenster" }[target] ?? "" : ""}
      ></x-dropdown-selection>
      <x-checkbox
        label="Button auf voller Breite?"
        ${contentController.field(...controllerBaseKeyPath, "fullWidth")}
      ></x-checkbox>
      <x-dropdown-selection
        placeholder="Button-Modus"
        .selectables=${["action", "outline", "text"]}
        ${contentController.field(...controllerBaseKeyPath, "mode")}
        .renderString=${(str) => str ? { action: "Prim\xE4r", outline: "Sekund\xE4r", text: "Text" }[str] ?? "" : ""}
      ></x-dropdown-selection>
    </x-flex>
  `;
};
var button = () => ({
  node: {
    name: BUTTON_KEY,
    schema: BUTTON_SCHEMA()
  },
  menuItems: [
    {
      label: "Knopf",
      icon: "videogame_asset",
      run: (view) => {
        runInsertNode(BUTTON_KEY, (state) => ({
          content: [state.schema.nodes[PARAGRAPH_KEY].create(null, state.schema.text("Button text"))]
        }))(view.state, view);
      },
      shouldVisualize: (view) => {
        return !isNodeSelection(view.state.selection);
      }
    }
  ],
  editor
});
var NodeButton = class extends BuildifyLitElement {
  content({ content, mode }) {
    return html`
      <x-button
        href=${content?.href}
        target=${content?.target}
        mode=${content?.mode ?? "action"}
        icon=${content?.icon ?? ""}
        ${css({ width: content?.fullWidth ? "100%" : "", boxSizing: "border-box" })}
      >
        <slot ${acss({ "&::slotted(*)": { marginBlock: "0 !important" } })}></slot>
      </x-button>
    `;
  }
  styles() {
    return [
      ...super.styles(),
      {
        ":host": {
          display: "inline-block",
          verticalAlign: "middle",
          width: this._data.value?.fullWidth ? "100%" : ""
        }
      }
    ];
  }
};
NodeButton = __decorateClass([
  customElement("node-button")
], NodeButton);
export {
  NodeButton,
  button
};
